// hooks/useToggle.ts
import axios from "axios";
import Cookies from 'universal-cookie';

// Set global defaults for Axios
axios.defaults.xsrfCookieName = 'csrftoken';
axios.defaults.xsrfHeaderName = 'X-CSRFToken';
axios.defaults.withCredentials = true; 

const checkCookieExists = (name: string) => {
  return document.cookie.split(';').some((item) => item.trim().startsWith(`${name}=`));
};

export const getCSRF = (): string => {
    const cookies = new Cookies();
    let csrftoken = cookies.get('csrftoken');

    if (!checkCookieExists('csrftoken')) {
        console.log("Retrieving Token..");
        axios.get(process.env.REACT_APP_API_URL + '/v1/session/init');
    }

    return cookies.get('csrftoken');
};